export default "__VITE_ASSET__D5l1wC6b__"